// extracted by mini-css-extract-plugin
export default {"pagination_wrapper":"pagination_pagination_wrapper__COUCb","page_size":"pagination_page_size__quOnH","custom_pagination":"pagination_custom_pagination__lpcWk"};